var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 8C9.10457 8 10 7.10457 10 6C10 4.89543 9.10457 4 8 4C6.89543 4 6 4.89543 6 6C6 7.10457 6.89543 8 8 8ZM9 6C9 6.55229 8.55229 7 8 7C7.44772 7 7 6.55229 7 6C7 5.44772 7.44772 5 8 5C8.55229 5 9 5.44772 9 6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.53765 8.5069C3.73936 11.0229 5.42711 13.5924 7.24968 15.6611C7.43953 15.8766 7.71287 16 8.00006 16C8.28725 16 8.56057 15.8765 8.7504 15.661C10.5727 13.5922 12.2603 11.0229 13.4623 8.50707C13.8202 7.75761 14 6.94819 14 6.10898C13.9997 2.87774 11.2807 0 7.99978 0C4.71889 0 2 2.87776 2 6.10894C2 6.94794 2.17991 7.75741 2.53765 8.5069ZM3 6.10894C3 6.80245 3.14799 7.46412 3.44 8.07591C4.45756 10.2063 5.83811 12.3803 7.34628 14.2286C7.56181 14.4927 7.77994 14.7502 8 15C8.22003 14.7502 8.43814 14.4927 8.65365 14.2285C10.1617 12.3801 11.5422 10.2063 12.56 8.07599C12.852 7.46439 13 6.80276 13 6.10898C12.9997 3.40257 10.7014 1 7.99978 1C5.29818 1 3 3.40265 3 6.10894Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.8dffe13e1ac5430846bab56245aba6da.svg";
export { ForwardRef as ReactComponent };